export const getSubstringBetween = (str: string, initial: string, end: string) => {
    const initialString = str.replace(/\\/g, '').replace(/<\/?p>/g, '');
    const startIndex = initialString.indexOf(initial);
    const endIndex = initialString.indexOf(end, startIndex);
    return initialString.slice(startIndex + initial.length, endIndex - 1);
};
